import React from 'react';

const TopActivitiesPratDashboardTable = (props) => (
    <div>
        <span className='top-ten-activities-table-heading' style={props.heading==='Pre OPSO - Bottom 5 Activities'?{marginTop:'20px'}:{}}>
            {props.heading}
        </span>
        <table className='top-ten-activities-table'>
            <thead>
                <tr className='heading-row'>
                    <th className='top-ten-activities-table-cell' style={{ textAlign: 'center', width:'13%' }}>Brand</th>
                    <th className='top-ten-activities-table-cell' style={{ textAlign: 'center', width:'30%' }}>Master SKU</th>
                    <th className='top-ten-activities-table-cell' style={{ textAlign: 'center', width:'37%' }}>Activity Description</th>
                    <th className='top-ten-activities-table-cell' style={{ textAlign: 'center', width:'8%' }}>Activity Cost</th>
                    <th className='top-ten-activities-table-cell' style={{ textAlign: 'center', width:'6%' }}>Inc Vol</th>
                    <th className='top-ten-activities-table-cell' style={{ width: '6%', textAlign: 'center' }}>ROI</th>
                </tr>
            </thead>

            <tbody>
                {
                    props.data && props.data.map((item,ind) => (
                        <tr key={ind} className='top-ten-activities-table-body-row'>
                            <td className='top-ten-activities-table-cell'>
                                <span className='cell-inner-container'>
                                    {item.Brands.length && item.Brands[0]}
                                    {item.Brands.length > 1 && <span className='cell-tag tooltip-cell-tag'>+{item.Brands.length - 1} more
                            <span className='tooltiptext-cell-tag'>
                                            {item.Brands.map((elm, ind) => (
                                                <span className='tooltip-text-tag' key={ind}>{elm}</span>
                                            ))}
                                        </span>
                                    </span>}
                                </span>
                            </td>
                            <td className='top-ten-activities-table-cell'>
                                <span className='cell-inner-container'>
                                    {item.MasterSkus.length && item.MasterSkus[0]}
                                    {item.MasterSkus.length > 1 && <span className='cell-tag tooltip-cell-tag'>+{item.MasterSkus.length - 1} more
                            <span className='tooltiptext-cell-tag'>
                                            {item.MasterSkus.map((elm, ind) => (
                                                <span className='tooltip-text-tag' key={ind}>{elm}</span>
                                            ))}
                                        </span>
                                    </span>}
                                </span>
                            </td>
                            <td className='top-ten-activities-table-cell'>{item.AcitivityDesc}</td>
                            <td className='top-ten-activities-table-cell' style={{ paddingRight: '8px', textAlign: 'right' }}>
                                {item.TotalCost.toLocaleString()}</td>
                            <td className='top-ten-activities-table-cell' style={{ paddingRight: '8px', textAlign: 'right' }}>
                                {item.IncVolume.toLocaleString()}</td>
                            <td className='top-ten-activities-table-cell' style={{ paddingRight: '8px', textAlign: 'right' }}>
                                {item.Roi.toLocaleString()}%</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
    </div>
);

export default TopActivitiesPratDashboardTable;
